export default (state, id) => state.find((t) => t.id === id)
